import { message } from 'antd';
import { getConversations } from '../MessagesServices';
import { useCallback } from 'react';

const useConversations = () => {
    const fetchConversations = useCallback(async ({
        page,
        perPage,
        selectedAgent,
        setConversations,
        setHasNextPage,
        filters,
        setLoading,
        shouldAppend,
        search_string,
        sort_by,
        sort_direction,
    }) => {
        if (!selectedAgent) return;

        setLoading(true);
        try {
            const { data, metadata } = await getConversations({
                page: page,
                size: perPage,
                agent_id: selectedAgent,
                filters,
                search_string,
                sort_by,
                sort_direction,
            });

            setHasNextPage(metadata.has_next);
            setConversations(prev => shouldAppend ? [...prev, ...data] : data);
        } catch (error) {
            message.error(error.response?.data?.message || 'Failed to load conversations');
        } finally {
            setLoading(false);
        }
    }, []);

    return { fetchConversations };
};

export default useConversations;